define('modules/list/list_item_collection',['backbone', './list_item_model'], function(Backbone, ListItem) {
 'use strict';
 var ListItemCollection = Backbone.Collection.extend({
  model: ListItem,
  initialize: function(models, options) {

  }
});

 return ListItemCollection;
});
